<template>
  <div class="container mt-4">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres
          titulo="Dados do Perfil"
          :botoes="botoesHeader"
          breakpoint="xl"
        />
      </template>

      <b-card>
        <b-container>
          <b-row style="text-align: center">
            <b-col cols="12" lg="6">
              <b-form-group>
                <span style="font-weight: bold">Nome:</span>
                <span style="margin-left: 5px">{{ usuario?.NOME }}</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <span style="font-weight: bold">CPF:</span>
                <span style="margin-left: 5px">{{ usuario?.CPF }}</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <span style="font-weight: bold">Email:</span>
                <span style="margin-left: 5px">{{ usuario?.EMAIL }}</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <span style="font-weight: bold">Telefone:</span>
                <span style="margin-left: 5px">{{ usuario?.NM_TELEFONE }}</span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>

        <b-card-group deck>
          <b-card header="Atualizar e-mail">
            <b-card-text
              >Para atualizar o seu e-mail de cadastro, insira o novo endereço
              no campo em branco e clique em atualizar.</b-card-text
            >
            <b-container>
              <b-row>
                <b-col sm="12">
                  <b-form @submit="atualizarEmail">
                    <b-overlay :show="loadingEmail">
                      <div
                        class="d-flex flex-column flex-sm-row align-items-center"
                      >
                        <b-form-input
                          v-model="novoEmail"
                          placeholder="Digite seu novo e-mail"
                          type="email"
                          class="mb-2 mb-sm-0 flex-grow-1"
                        ></b-form-input>
                        <b-button
                          class="ml-0 ml-sm-3 d-flex align-items-center"
                          :disabled="novoEmail === ''"
                          type="submit"
                          size="sm"
                          variant="success"
                        >
                          <div>Atualizar</div>
                          <div class="ml-2">
                            <font-awesome-icon icon="arrows-rotate" />
                          </div>
                        </b-button>
                      </div>
                    </b-overlay>
                  </b-form>
                </b-col>
              </b-row>
            </b-container>
          </b-card>
          <b-card header="Comunicação">
            <b-overlay :show="loadingComunicacao">
              <div>
                <b-form-checkbox
                  id="checkbox-1"
                  name="checkbox-1"
                  v-model="preferenciaComunica"
                  @change="mudancaCheckBox"
                  class="text-left"
                >
                  Autorizo o TCE-SE a me informar, por e-mail, SMS ou mecanismos
                  de comunicações afins, sobre movimentações de protocolos e
                  processos onde figuro como interessado.
                </b-form-checkbox>
              </div>
            </b-overlay>
          </b-card>
        </b-card-group>
      </b-card>
    </b-card>
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { BotaoSagres } from "@/types/botao-sagres";
import usuarioService from "@/services/administracao/usuarioService";
import { Usuario } from "@/types/administracao/usuarios/usuario";
import { store } from "@/store";
const CompProps = Vue.extend({
  name: "ExibirPerfil",
  components: { HeaderSagres },
});

@Component
export default class ExibirPerfil extends mixins(UtilsTS, CompProps) {
  loadingEmail = false;
  loadingComunicacao = false;
  usuario: Usuario | null = null;
  novoEmail = "";
  preferenciaComunica = false;
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: "lock",
      texto: "Alterar senha",
      url: "/seguranca-administracao/trocar-senha",
    },
  ];

  created() {
    this.obterUsuario();
  }
  //Recupera o usuário que está logado
  async obterUsuario() {
    try {
      store.blockScreen = true;
      const response = await usuarioService.meuPerfil();
      this.usuario = response;
      this.preferenciaComunica = this.usuario?.FL_COMUNICA_TELEFONE;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
      //console.log(this.usuario)
    }
  }
  //Chama a função de alterar e-mail
  async atualizarEmail(event: Event) {
    event.preventDefault();
    //console.log(this.novoEmail)
    try {
      this.loadingEmail = true;
      const data = { EMAIL: this.novoEmail };
      const response = await usuarioService.trocarEmail(data);
      this.$toast.success("E-mail atualizado com sucesso!");
      this.novoEmail = "";
      store.forceQuit = true;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.loadingEmail = false;
    }
  }

  //Chama a função de alterarComunicação sempre que o checkbox for marcado/desmarcado
  async mudancaCheckBox(opcao: boolean) {
    try {
      this.loadingComunicacao = true;
      const response = await usuarioService.alterarComunicacao(opcao);
      this.$toast.success("Preferência alterada com sucesso!");
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.loadingComunicacao = false;
    }
  }
}
</script>
